@if (title) {
<atx-modal-header class="py-1" (dismiss)="close()">
  {{ title }}
</atx-modal-header>
}

<atx-modal-body class="d-flex flex-column">
  @for (link of links; track link) {
  <a [href]="link.href" target="_blank">{{ link.text }}</a>
  }
</atx-modal-body>
